import { Outlet, useLocation } from "react-router-dom";
import PortalBreadcrumb from "../UI/Breadcrumb/PortalBreadcrumb/PortalBreadcrumb";
import {
  PROFILE_WALLET_CRUMBS,
  PROFILE_PREVIOUS_ORDERS_CRUMBS,
  PROFILE_CRUMBS,
} from "../../constants/crumbs";
import { APP_PATHS } from "../../constants/paths";
import SideMenu from "./SideMenu/SideMenu";
import classes from "./Profile.module.css";

const Profile = () => {
  const { pathname: currentPath } = useLocation();
  return (
    <div className={classes["profile"]}>
      <PortalBreadcrumb
        paths={
          currentPath === APP_PATHS.WALLET.url
            ? PROFILE_WALLET_CRUMBS
            : currentPath === APP_PATHS.PREVIOUS_ORDERS.url
            ? PROFILE_PREVIOUS_ORDERS_CRUMBS
            : PROFILE_CRUMBS
        }
      />
      <div className={classes["profile__main-content-wrapper"]}>
        <SideMenu />
        <div className={classes["profile__main-content"]}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Profile;
